export default __webpack_public_path__ + "static/media/Java.fb0d9fb5.png";